'use client';

interface Params {
  [index: string]: string | number | null;
}

import { usePathname, useRouter, useSearchParams } from 'next/navigation';

export default function useParamsEditor() {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  return (
    param: Params | string,
    value: string | number | null = null,
    reset: boolean = false
  ) => {
    let current: URLSearchParams;
    if (reset) {
      current = new URLSearchParams('');
    } else {
      current = new URLSearchParams(Array.from(searchParams.entries()));
    }
    let params = {} as Params;
    if (typeof param === 'string' || param instanceof String) {
      params[String(param)] = value;
    } else {
      params = param;
    }
    Object.entries(params).forEach((parameter) => {
      if (parameter[1]) {
        current.append(parameter[0], String(parameter[1]));
        current.set(parameter[0], String(parameter[1]));
      } else {
        current.delete(parameter[0]);
      }
    });
    const search = current.toString();
    const query = search ? `?${search}` : '';
    router.push(`${pathname}${query}`);
  };
}
